import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import logger from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import storage from 'redux-persist/lib/storage';

import * as Sentry from '@sentry/react';
import spaceReducers, { clearSpaceData } from './reducers/spaceReducers';
import currentPlanReducers, {
  clearCurrentPlanData
} from './reducers/currentPlanReducer';
import allPlansReducers, {
  clearAllPlansData
} from './reducers/allPlanReducers';
import freeTrialEligibilityReducers, {
  clearFreeTrialEligibility
} from './reducers/freeTrialEligibilityReducers';
import spaceDevicesInDetailReducers, {
  clearSpaceDevices
} from './reducers/deviceInSpaceReducers';
import paymentMethodsReducers, {
  clearPaymentMethods
} from './reducers/paymentMethodsReducers';
import invoiceReducers, { clearInvoices } from './reducers/invoicesReducers';
import subscriptionReducer, {
  clearSubscriptionData
} from './reducers/subscriptionReducer';
import userReducers, { clearUser } from './reducers/userReducers';
import birdPlansReducers, {
  clearBirdPlansData
} from './reducers/birdPlansReducer';

const blacklistUserProperties = createBlacklistFilter('user', ['isLoading']);

const persistConfig = {
  key: 'root',
  storage,
  transforms: [blacklistUserProperties]
};

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const rootReducer = combineReducers({
  user: userReducers,
  space: spaceReducers,
  subscription: subscriptionReducer,
  allPlans: allPlansReducers,
  currentPlan: currentPlanReducers,
  trial: freeTrialEligibilityReducers,
  spaceDevices: spaceDevicesInDetailReducers,
  invoices: invoiceReducers,
  paymentMethods: paymentMethodsReducers,
  birdPlans: birdPlansReducers
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }),
  enhancers: (existingEnhancers) => [...existingEnhancers, sentryReduxEnhancer]
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const clearReduxStates = () => {
  store.dispatch(clearUser());
  store.dispatch(clearSubscriptionData());
  store.dispatch(clearSpaceData());
  store.dispatch(clearSpaceDevices());
  store.dispatch(clearAllPlansData());
  store.dispatch(clearCurrentPlanData());
  store.dispatch(clearFreeTrialEligibility());
  store.dispatch(clearInvoices());
  store.dispatch(clearPaymentMethods());
  store.dispatch(clearBirdPlansData());
};

export const LogoutUser = () => {
  clearReduxStates();
  localStorage.clear();
};
